// Themes
export const THEMES = {
  DEFAULT: "DEFAULT",
  DARK: "DARK",
  LIGHT: "LIGHT",
  BLUE: "BLUE",
  GREEN: "GREEN",
  INDIGO: "INDIGO",
};

export const ACTIVECONCERN = {
  // constants.js
  GREEN_COLOR: "#00C853",
  RED_COLOR: "#F00",
  SHAPE_WIDTH: 10,
  SHAPE_HEIGHT: 10,
  BORDER_RADIUS: "50%",
};

export const ID_FIELD_VALIDATION_STR =
  "IDs must contain at least 3 characters and can only contain lowercase letters, numbers, and the following special characters in between: - (dash)";
